<template>
  <ul v-if="hasChildren(items)">
    <slot
      name="header"
      :item="items"
      :indentation="indentation"
    >
      <li>
        {{ items[labelKey] }}
      </li>
    </slot>

    <BaseComboItem
      v-for="(item, index) in items[childrenKey]"
      :key="index"
      :items="item"
      :selected="selected"
      :indentation="indentation + 2"
      :label-key="labelKey"
      :value-key="valueKey"
      :children-key="childrenKey"
    >
      <template
        v-for="(_, slot) in $slots"
        #[slot]="scope"
      >
        <slot
          :name="slot"
          v-bind="{ ...scope }"
        />
      </template>
    </BaseComboItem>
  </ul>
  <slot
    v-else-if="hasLabelAndValue(items)"
    name="item"
    :item="items"
    :indentation="indentation"
  >
    <li>
      <span>{{ items[labelKey] }}</span>
    </li>
  </slot>
</template>

<script setup>
const items = defineModel('items', {
	type: [Array, Object],
	required: true
});

const props = defineProps({
	indentation: {
		type: Number,
		default: 0
	},
	autoIndent: {
		type: Boolean,
		default: true
	},
	labelKey: {
		type: String,
		default: 'text'
	},
	valueKey: {
		type: String,
		default: 'value'
	},
	childrenKey: {
		type: String,
		default: 'values'
	}
});

const selected = defineModel('selected', {
	type: Array,
	default: []
});

function isArray (value) {
	return Array.isArray(value);
}

function hasChildren (item) {
	return item && item[props.childrenKey] && Array.isArray(item[props.childrenKey]);
}

function hasLabelAndValue (item) {
	return item && item[props.labelKey] && item[props.valueKey];
}
</script>


<style scoped>
li {
  cursor: pointer;
  padding: 0.5rem;
  /* border-bottom: 1px solid #ccc; */
}

li:hover {
  background-color: #f9f9f9;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

ul ul li:not(:first-child) {
 padding-left: 2rem;
}
</style>
